export default __webpack_public_path__ + "static/media/personnalite.592e3fec.png";